import React from 'react';
import createTrack from 'services/actions/tracker_actions';
import { Button } from './styles';

interface HelpMenuItemProps {
  item: string;
  current: boolean;
  selectPage: () => void;
}

const HelpMenuItem = (props: HelpMenuItemProps) => {
  const { item, current, selectPage } = props;

  return (
    <Button
      type="button"
      onClick={() => {
        selectPage();
        createTrack('Clicou no menu em Ajuda', { fonte: item });
      }}
      className={`list-group-item list-group-item-action ${current ? 'current' : ''}`}
    >
      {item}
    </Button>
  );
};

export default HelpMenuItem;
